import React from 'react';
import ReactApexChart from "react-apexcharts";

import getChartColorsArray from "../../Components/Common/ChartsDynamicColor";

const Line = ({forecastBudget, forecastLastYear, forecastData, dataColors}) => {
    var chartLineColumnColors = getChartColorsArray(dataColors);
    var option_enabledOnSeries=[1];
    var option_stroke_width=[0,4];

    var revenue_max=Math.max(...forecastData.revenue);
    var covers_max=Math.max(...forecastData.covers)+10;
    if(forecastBudget===true && forecastLastYear===true){
        revenue_max=Math.max(revenue_max,...forecastData.revenue_budget,...forecastData.revenue_lastyear);
        covers_max=Math.max(covers_max,...forecastData.covers_budget,...forecastData.covers_lastyear);
    }else if(forecastBudget===true){
        revenue_max=Math.max(revenue_max,...forecastData.revenue_budget);
        covers_max=Math.max(covers_max,...forecastData.covers_budget);
    }else if(forecastLastYear===true){
        revenue_max=Math.max(revenue_max,...forecastData.revenue_lastyear);
        covers_max=Math.max(covers_max,...forecastData.covers_lastyear);
    }

    var yaxisData=[
        {
          seriesName: "Revenue",
          title: {
            text: "Revenue Forecast (USS)",
            style: {
              fontWeight: 600,
            },
          },
          min: 0,
          max: revenue_max,
          labels: {
            formatter: function (value) {
                return value.toFixed(0);
            },
        },
        },
        {
          seriesName: "Covers",
          opposite: true,
          title: {
            text: "Covers",
            style: {
              fontWeight: 600,
            },
          },
          min: 0,
          max: covers_max,
          labels: {
            formatter: function (value) {
                return value.toFixed(0);
            },
        },
        }
    ];
    const series = [
        {
            name: "Revenue",
            type: "column",
            data: forecastData.revenue,
        },
        {
            name: "Covers",
            type: "line",
            data: forecastData.covers,
        }
    ];
    if(forecastBudget===true){
        series.push({
            name: "Budget Revenue",
            type: "column",
            data: forecastData.revenue_budget,
        });
        series.push({
            name: "Budget Covers",
            type: "line",
            data: forecastData.covers_budget,
        });
        option_stroke_width.push(0,4);
        yaxisData.push({
            seriesName: "Budget Revenue",
            show: false,
            min: 0,
            max: revenue_max,
            labels: {
                formatter: function (value) {
                    return value.toFixed(0);
                },
            },
        });
        yaxisData.push({
            seriesName: "Budget Covers",
            opposite: true,
            show: false,
            min: 0,
            max: covers_max,
            labels: {
                formatter: function (value) {
                    return value.toFixed(0);
                },
            },
        });
    }
    if(forecastLastYear===true){
        series.push({
            name: "LastYear Revenue",
            type: "column",
            data: forecastData.revenue_lastyear,
        });
        series.push({
            name: "LastYear Covers",
            type: "line",
            data: forecastData.covers_lastyear,
        });
        option_stroke_width.push(0,4);
        yaxisData.push({
            seriesName: "LastYear Revenue",
            show: false,
            min: 0,
            max: revenue_max,
            labels: {
                formatter: function (value) {
                    return value.toFixed(0);
                },
            },
        });
        yaxisData.push({
            seriesName: "LastYear Covers",
            opposite: true,
            show: false,
            min: 0,
            max: covers_max,
            labels: {
                formatter: function (value) {
                    return value.toFixed(0);
                },
            },
        });
    }
    if(forecastBudget===true && forecastLastYear===true){
        option_enabledOnSeries.push(3,5);
    }else if(forecastBudget===true || forecastLastYear===true){        
        option_enabledOnSeries.push(3);
    }
    var date = new Date();
    var customlabels=['Today'];
    for(let i=1;i<=6;i++){
        date.setDate(date.getDate() + 1);
        customlabels.push((date.toLocaleString('en-us', { day: '2-digit' }))+'-'+(date.toLocaleString('en-us', { month: 'short' })));
    }
    const options = {
        chart: {
          toolbar: {
            show: true,
          },
        },
        stroke: {
          width: option_stroke_width,
        },
        title: {
          text: ''
        },
        dataLabels: {
          enabled: true,
          enabledOnSeries: option_enabledOnSeries,
        },
        labels: customlabels,
        xaxis: {
          type: "category",
        },
        yaxis: yaxisData,
        colors: chartLineColumnColors,
        plotOptions: {
            bar: {
                columnWidth: "40%",
            },
        },
    };
    return (
        <React.Fragment>
            <ReactApexChart
                options={options}
                series={series}
                type="line"
                height={350}
            />
        </React.Fragment>
    );
};

const LineColumnArea = ({forecastBudget, forecastLastYear, forecastData, dataColors}) => {
    var chartLineAreaMultiColors = dataColors;
    var option_stroke_width=[0, 2, 5];
    var option_fill_opacity=[0.85, 0.25, 1];
    var seat_occupancy_max=Math.max(...forecastData.seat_occupancy,...forecastData.average_check)+10;
    var RevPASH_max=Math.max(...forecastData.revPASH)+10;
    if(forecastBudget===true && forecastLastYear===true){
        seat_occupancy_max=Math.max(seat_occupancy_max,...forecastData.seat_occupancy_budget,...forecastData.average_check_budget,...forecastData.seat_occupancy_lastyear,...forecastData.average_check_lastyear)+30;
        RevPASH_max=Math.max(...forecastData.revPASH,...forecastData.revPASH_budget,...forecastData.revPASH_lastyear)+30;
    }else if(forecastBudget===true){
        seat_occupancy_max=Math.max(seat_occupancy_max,...forecastData.seat_occupancy_budget,...forecastData.average_check_budget)+20;
        RevPASH_max=Math.max(...forecastData.revPASH,...forecastData.revPASH_budget)+20;
    }else if(forecastLastYear===true){
        seat_occupancy_max=Math.max(seat_occupancy_max,...forecastData.seat_occupancy_lastyear,...forecastData.average_check_lastyear)+20;
        RevPASH_max=Math.max(...forecastData.revPASH,...forecastData.revPASH_lastyear)+20;
    }
    var yaxisData=[
        {
            seriesName: "Seat Occupancy",
            title: {
                text: "Occupancy(%)"
            },
            max: seat_occupancy_max,
        },
        {
            seriesName: "Average Check",
            show: false,
            min: 0,
            max: seat_occupancy_max,
        },
        {
            seriesName: "RevPASH",
            opposite: true,
            title: {
                text: "RevPASH"
            },
            max: RevPASH_max,
        }
    ];
    const series = [
        {
            name: "Seat Occupancy",
            type: "column",
            data: forecastData.seat_occupancy,
        },
        {
            name: "Average Check",
            type: "area",
            data: forecastData.average_check,
        },
        {
            name: "RevPASH",
            type: "line",
            data: forecastData.revPASH,
        },
    ];
    if(forecastBudget===true){
        series.push({
            name: "Budget Seat Occupancy",
            type: "column",
            data: forecastData.seat_occupancy_budget,
        });
        series.push({
            name: "Budget Average Check",
            type: "area",
            data: forecastData.average_check_budget,
        });
        series.push({
            name: "Budget RevPASH",
            type: "line",
            data: forecastData.revPASH_budget,
        });
        option_stroke_width.push(0, 2, 5);
        option_fill_opacity.push(0.85, 0.25, 1);
        yaxisData.push({
            seriesName: "Budget Seat Occupancy",
            show: false,
            min: 0,
            max: seat_occupancy_max,
        });
        yaxisData.push({
            seriesName: "Budget Average Check",
            show: false,
            min: 0,
            max: seat_occupancy_max,
        });
        yaxisData.push({
            seriesName: "Budget RevPASH",
            show: false,
            min: 0,
            max: RevPASH_max,
        });
    }
    if(forecastLastYear===true){
        series.push({
            name: "LastYear Seat Occupancy",
            type: "column",
            data: forecastData.seat_occupancy_lastyear,
        });
        series.push({
            name: "LastYear Average Check",
            type: "area",
            data: forecastData.average_check_lastyear,
        });
        series.push({
            name: "LastYear RevPASH",
            type: "line",
            data: forecastData.revPASH_lastyear,
        });
        option_stroke_width.push(0, 2, 5);
        option_fill_opacity.push(0.85, 0.25, 1);
        yaxisData.push({
            seriesName: "LastYear Seat Occupancy",
            show: false,
            min: 0,
            max: seat_occupancy_max,
        });
        yaxisData.push({
            seriesName: "LastYear Average Check",
            show: false,
            min: 0,
            max: seat_occupancy_max,
        });
        yaxisData.push({
            seriesName: "LastYear RevPASH",
            show: false,
            min: 0,
            max: RevPASH_max,
        });
    }
    var date = new Date();
    var customlabels=['Today'];
    for(let i=1;i<=6;i++){
        date.setDate(date.getDate() + 1);
        customlabels.push((date.toLocaleString('en-us', { day: '2-digit' }))+'-'+(date.toLocaleString('en-us', { month: 'short' })));
    }
    const options = {
        chart: {
            stacked: !1,
            toolbar: {
                show: true,
            },
        },
        stroke: {
            width:option_stroke_width,
            curve: "smooth",
        },
        plotOptions: {
            bar: {
                columnWidth: "40%",
            },
        },

        fill: {
            opacity: option_fill_opacity,
            gradient: {
                inverseColors: !1,
                shade: "light",
                type: "vertical",
                opacityFrom: 0.85,
                opacityTo: 0.55,
                stops: [0, 100, 100, 100],
            },
        },
        labels: customlabels,
        markers: {
            size: 0,
        },
        xaxis: {
            type: "category",
        },
        yaxis: yaxisData,
        tooltip: {
            shared: !0,
            intersect: !1,
            y: {
                formatter: function (y) {
                    if (typeof y !== "undefined") {
                        return y.toFixed(0) + "";
                    }
                    return y;
                },
            },
        },
        colors: chartLineAreaMultiColors,
    };
    return (
        <React.Fragment>
            <ReactApexChart
                options={options}
                series={series}
                type="line"
                height={350}
            />
        </React.Fragment>
    );
};

export {
    Line,
    LineColumnArea
};